import React, { type FC } from 'react'

import styled from '@emotion/styled'

import { useIntl } from 'react-intl'

import {
  BUTTON_VARIANT_SECONDARY,
  Button,
  Flex,
  HelpIcon,
  LINK_VARIANT_HIGHLIGHT,
  Link,
  TEXT_VARIANT_BOLD,
  Text,
  TooltipUtils,
} from 'mailup-web-components'

import { STORE_KEY_ACCOUNT, notifyParent, storeGet } from 'mailup-react-helpers'

import { isEcommerceVisible } from 'Helpers/ecommerce'

import { offerType } from 'Constants'

const SmallText = styled(Text)`
  font-size: 13px !important;
`

const StyledHelpIcon = styled(HelpIcon)`
  pointer-events: all;

  align-self: center;
`

const ActionAddSegmentUpselling: FC = () => {
  const { IdOffer } = storeGet(STORE_KEY_ACCOUNT)

  const intl = useIntl()

  const canUpgrade =
    isEcommerceVisible() &&
    (IdOffer === offerType.StarterEdition || IdOffer === offerType.LightEdition)

  const handleUpgrade = (): void => {
    notifyParent('redirectMainFrame', ['mshop_Redirector.aspx?t=mshoppcb'])
  }

  return (
    <>
      <TooltipUtils
        id="segment-upselling"
        type="light"
        effect="solid"
        className="c-tooltip"
        event="click"
        globalEventOff="click"
        clickable
      >
        <p>
          {intl.formatMessage(
            {
              id: 'Load.RecipientsList.SegmentUpsellingTooltip',
            },
            {
              strong: (chunks) => <strong>{chunks}</strong>,
              linebreak: <br />,
            },
          )}{' '}
          {canUpgrade ? (
            <Link
              variant={LINK_VARIANT_HIGHLIGHT}
              data-mu-test="segment-upselling-buy"
              onClick={handleUpgrade}
            >
              {intl.formatMessage({ id: 'Load.Common.UpgradePlan' })}
            </Link>
          ) : (
            <SmallText
              htmlElement="span"
              variant={TEXT_VARIANT_BOLD}
              data-mu-test="segment-upselling-contact"
            >
              {intl.formatMessage({ id: 'Load.Common.ContactSales' })}
            </SmallText>
          )}
        </p>
      </TooltipUtils>

      <Button
        kind={BUTTON_VARIANT_SECONDARY}
        data-mu-test="add-segment-upselling"
        disabled
      >
        <Flex alignItems="center">
          <span>
            {intl.formatMessage({ id: 'Load.RecipientsList.SegmentAddCta' })}
          </span>

          <StyledHelpIcon
            inline={false}
            data-for="segment-upselling"
            data-tip
          />
        </Flex>
      </Button>
    </>
  )
}

export default ActionAddSegmentUpselling
